import {
	CsvDownloadPerReservationForReservationSearch,
	CsvDownloadPerStayDateForReservationSearch,
} from "../compositions";

import type * as Model from "../../model";

type Props = {
	viewData: Model.Type.ViewData;
};

export const AboutForSearchResultTable = ({ viewData }: Props) => {
	return (
		<div className="flex items-center gap-x-10">
			<div className="flex flex-wrap gap-x-4 gap-y-2">
				{/* 検索件数 */}
				<p>件数：{viewData.searchResultTableData.searchResultCountText}</p>

				{/* 売り上げ合計 */}
				<p>売り上げ合計：{viewData.searchResultTableData.totalSalesAmountText}</p>
			</div>

			{/* mobile 時は表示しない */}
			<div className="hidden tablet:flex tablet:gap-x-4">
				{/* CSVダウンロード（宿泊ごと） */}
				<CsvDownloadPerReservationForReservationSearch viewData={viewData} />

				{/* CSVダウンロード（宿泊日ごと） */}
				<CsvDownloadPerStayDateForReservationSearch viewData={viewData} />
			</div>
		</div>
	);
};
